'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _immutable = require('immutable');

var _TransmuteCollection = require('./TransmuteCollection');

var jsToEntrySeq = function jsToEntrySeq(subject) {
  return (0, _immutable.Seq)(subject).entrySeq();
};

_TransmuteCollection.entrySeq.implement(Array, jsToEntrySeq);
_TransmuteCollection.entrySeq.implementInherited(_immutable.Iterable, function (subject) {
  return subject.entrySeq();
});
_TransmuteCollection.entrySeq.implement(Object, jsToEntrySeq);

exports.default = _TransmuteCollection.entrySeq;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/transmute/static-2.3/internal/_entrySeq.js
// module id = 360
// module chunks = 0 1